import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../register-builder/builder-module';
import { ABTest } from './ABTest';

export default createBuilderModule(withChildren(ABTest), {
  name: 'ABTest',
  image: 'https://cdn.zappy.app/0aa56417d6b262b93417a0b1340b95b6.png',
  inputs: [
    {
      name: 'experimentName',
      type: 'string',
      required: true,
      helperText: 'The name of experiment',
    },
    {
      name: 'variants',
      type: 'list',
      subFields: [
        {
          name: 'name',
          helperText: 'Each variant must have a unique name.',
          required: true,
          type: 'string',
        },
        {
          name: 'percent',
          required: true,
          type: 'number',
          helperText:
            'Percentage of users that should see this variant. Percents of all variants must add up to 100.',
        },
        {
          name: 'control',
          type: 'boolean',
          defaultValue: false,
        },
      ],
      required: true,
    },
  ],
});
